module.exports = __webpack_public_path__ + "media/customizations/sunbridge/back-1a858660785575ca4b4e27043ec7abd5.jpg";